import React, { useState, useEffect } from "react";
import { useList } from "store/list";
import * as Icons from "react-feather";

export default function ListSearch(props) {
  const WAIT_INTERVAL = 1000;
  const ENTER_KEY = 13;
  const { getList, dispatch, loading } = useList();
  let timer;

  const triggerSearch = (key) => {
    props.search(key);
  };

  const handleSearch = (e) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      triggerSearch(e.target.value);
    }, WAIT_INTERVAL);
  };

  return (
    <div className="w-full sm:w-auto flex justify-center sm:justify-start mt-3 sm:mt-0">
      <div className="relative w-full sm:w-56 text-gray-700 dark:text-gray-300">
        <input
          onChange={handleSearch}
          type="search"
          disabled={loading}
          className="w-full pl-10 pr-3 py-2 rounded-md border border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-violet-500 dark:bg-gray-800 dark:text-white placeholder-gray-400"
          placeholder="جستجو..."
        />
        <Icons.Search className="w-5 h-5 absolute inset-y-0 left-3 my-auto text-gray-500 dark:text-gray-400" />
      </div>
    </div>
  );
}
